<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.novelCode ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="小说名字" prop="novelName">
          <el-input v-model="dataForm.novelName" placeholder="小说名字"></el-input>
      </el-form-item>
          <el-form-item label="缩略图" prop="novelImage">
          <!-- <el-input v-model="dataForm.novelImage" placeholder="小说分类"></el-input> -->
          <el-upload
              class="avatar-uploader"
              :action="url"
              :show-file-list="false"
              :before-upload="beforeUploadHandle"
              :on-success="successHandle">
              <img v-if="novelImage" :src="novelImage" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
      </el-form-item>
      <el-form-item label="所属分类" prop="dictCode">
          <el-select v-model="dataForm.dictCode" placeholder="请选择分类">
            <el-option
              v-for="item in pDict"
              :key="item.dictCode"
              :label="item.dictName"
              :value="item.dictCode">
            </el-option>
          </el-select>
      </el-form-item>
          <el-form-item label="状态" prop="novelSeria">
          <el-radio-group v-model="dataForm.novelSeria">
              <el-radio :label="0">连载</el-radio>
              <el-radio :label="1">完结</el-radio>
            </el-radio-group>
      </el-form-item>
          <el-form-item label="热度" prop="novelHot">
          <el-input v-model="dataForm.novelHot" placeholder="热度(多少人在读)"></el-input>
      </el-form-item>
      <el-form-item label="全本价钱" prop="novelPrice">
          <el-input v-model="dataForm.novelPrice" placeholder="全本价钱(金币)"></el-input>
      </el-form-item>
      <el-form-item label="单章价钱" prop="chapterPrice">
          <el-input v-model="dataForm.chapterPrice" placeholder="单章价钱(金币)"></el-input>
      </el-form-item>
          <el-form-item label="更新详情" prop="novelAuthor">
          <el-input v-model="dataForm.novelAuthor" placeholder="更新详情"></el-input>
      </el-form-item>
          <el-form-item label="小说简介" prop="novelIntroduce">
          <el-input v-model="dataForm.novelIntroduce" placeholder="小说简介"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
<script>
import debounce from 'lodash/debounce'
import Cookies from 'js-cookie'
export default {
  data () {
    return {
      visible: false,
      url:'',
      novelImage: '',
      type:'1',
      pDict:[],
      dataForm: {
        novelCode: '',
        novelName: '',
        novelPrice: '',
        chapterPrice: '',
        dictCode:'',
        novelImage: '',
        novelSeria: '',
        novelHot: '',
        novelAuthor: '',
        novelIntroduce: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        novelName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        novelImage: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        novelSeria: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        novelHot: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        dictCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        novelPrice: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        chapterPrice: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        novelAuthor: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        novelIntroduce: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.getpDict()
      this.url = `${process.env.VUE_APP_API_TARGET}${process.env.VUE_APP_BASE_API}/sys/oss/upload?token=${Cookies.get('token')}`
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.novelCode) {
          this.getInfo()
        }
      })
    },
     // 上传之前
     beforeUploadHandle (file) {

       return true;
   },
       // 上传成功
   successHandle (res, file) {
     if(res.code == 0){
       this.novelImage = res.data.src,
       this.dataForm.novelImage = res.data.src
     }else{
       return this.$message.error(res.msg)
     }
   },
    // 获取信息
    getInfo () {
      this.$http.get(`/novel/novel/${this.dataForm.novelCode}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
       this.novelImage = this.dataForm.novelImage
      }).catch(() => {})
    },
    getpDict() {
      this.$http.get(`/sondict/sondict/getpDict/${this.type}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.pDict = res.data
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }

        this.dataForm.novelIntroduce = encodeURIComponent(this.dataForm.novelIntroduce )
        this.$http[!this.dataForm.novelCode ? 'post' : 'put']('/novel/novel/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
